import ValidationError from 'media-base-ui/utils/ValidationError';

// if the value we just updated is related to an error in our state we want to clear the error
export default actionType => (state, action) => {
    if (action.type === actionType) {
        const { payload } = action;
        const { errors } = state;

        if (errors) {
            // first we try to find any related errors
            const relatedErrors = errors.filter(error => error.getElementNames().includes(payload.name));

            if (relatedErrors.length > 0) {
                // if we have any we create a new errors array without those errors in it
                const errorsWithoutRelatedError = errors.filter(error => !error.getElementNames().includes(payload.name));

                // if there were other elements related to the errors, we still want to show the error for them
                // so we create a new ValidationError with all elements except this one retained and push it
                // into our new error array
                relatedErrors.forEach(relatedError => {
                    if (relatedError.getElementNames().length > 1) {
                        const newElementNames = relatedError.getElementNames().filter(elName => elName !== payload.name);
                        errorsWithoutRelatedError.push(new ValidationError(relatedError.getMessage(),
                            relatedError.getElementMessage(), ...newElementNames));
                    }
                });

                // It probably seems odd to be returning the entire loadingState object.
                // This is a function of how this reducer gets added to our reducer stack. We're using a library called
                // reduce-reducers which chains any number of reducers together from left to right. Because we only get a combined reducer out of
                // the loadingStateReducerFactory which only returns the whole loadingState object we have to continue
                // to return the whole thing on any subsequent reducers. Because nothing else could change
                // isLoading or success we just return their values from the state object given to us.
                //
                // This library is also the reason why the state object given to this reducer does not have any
                // default value specified - reduceReducers expects that the state has already been initialized
                // in the first reducer so specifying a default is no longer necessary.
                return {
                    isLoading: state.isLoading,
                    success: state.success,
                    errors: errorsWithoutRelatedError
                };
            }
        }
    }

    return state;
}